import React from 'react'
import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid'
import { LabeledValue } from 'antd/es/select'
import { CurrencyType } from 'api/Wallet/Types/Wallet'
import AddButton from 'components/AddButton/AddButton'
import { FlexBox } from 'components/Box'
import { FormBaseFieldBlock, FormBaseFieldGroup } from 'components/Form/Form.styles'

interface CampaignCurrencyTableProps {
  currencies: LabeledValue[]
  currenciesMinDeposit: Record<CurrencyType, number>
  isEdit: boolean
  onCurrencyModalOpen(): void
  className?: string
}

export const CampaignDetailsCurrencyTable: React.FC<CampaignCurrencyTableProps> = (props) => {
  const { currencies, currenciesMinDeposit, isEdit, onCurrencyModalOpen } = props

  return (
    <FormBaseFieldBlock>
      <FormBaseFieldGroup style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
        <FlexBox>
          <AddButton disabled={!isEdit} text='Edit' onClick={onCurrencyModalOpen} />
        </FlexBox>
        <Grid data={currencies} resizable className={props.className}>
          <GridColumn field='label' title='Currency' />
          <GridColumn
            field='value'
            title='Min Deposit'
            cell={(gridCellProps: GridCellProps) => (
              <td>
                {currenciesMinDeposit[gridCellProps.dataItem.label as CurrencyType] ?? 'Not set'}
              </td>
            )}
          />
        </Grid>
      </FormBaseFieldGroup>
    </FormBaseFieldBlock>
  )
}
